import React from 'react';
import styled from 'styled-components';
import { Avatar, Card, Text } from 'components';
import { VerticalSpace, CenterTextWrapper } from '@brokerbay/design-components';

import { buildOrgAddress } from 'utils';
import { UserLocalOnboardingProfile } from '../types';

type OnboardingDetailsProps = {
  profile: Pick<UserLocalOnboardingProfile, 'address' | 'location'> & {
    org: Pick<
      UserLocalOnboardingProfile['org'],
      'addresses' | 'logoUrl' | 'name'
    >;
  };
};

export const OnboardingOrgDetails = (props: OnboardingDetailsProps) => {
  const { profile } = props;

  const { org } = profile;

  if (!org) return null;

  const addressIndex = parseInt(profile.address, 10);
  const locationIndex = parseInt(profile.location, 10);

  const office = org.addresses[locationIndex][addressIndex];

  const officeAddress = buildOrgAddress(office, 2);

  return (
    <Card>
      <CenterTextWrapper>
        <VerticalSpace>
          <Avatar src={org.logoUrl} />

          <TextContainer>
            <Text strong>{org.name}</Text>
            <Text strong>{office.name}</Text>
          </TextContainer>

          <Text type="secondary">{officeAddress[0]}</Text>
          <Text type="secondary">{officeAddress[1]}</Text>
        </VerticalSpace>
      </CenterTextWrapper>
    </Card>
  );
};

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
